import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import EyeIcon from "../../assets/images/icons/eye_on.svg";
import EyeIconClosed from "../../assets/images/icons/eye_off.svg";
import "./style.scss";
import PropTypes from "prop-types";
import SocialLogins from "../SocialLogins";
import { setActivityIndicator } from "../../redux/slices/appconfigSlice";
import { LoginService } from "../../services/LoginService";
import { getLoginConfig, setIsLogin, setLoginUser } from "../../redux/slices/loginconfigSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import useTranslationCustom from "../../i18n/customHook/useTranslation";
import { ServicePostUserObject } from "../../services/NotificationService";

const SignIpModal = (props) => {
    const dispatch = useDispatch();
    const { T } = useTranslationCustom();
    const loginConfig = useSelector(getLoginConfig);
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [inputType, setInputType] = useState(false);

    useEffect(() => {
        if (!props.show) {
            setEmail("");
            setPassword("");
        }
    }, [props.show]);

    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(setActivityIndicator(true));
        LoginService({ Email: email, Password: password, Locale: loginConfig?.locale?.code })
            .then(async (_loginResponse) => {
                dispatch(setLoginUser(_loginResponse));
                dispatch(setIsLogin(true));
                dispatch(setActivityIndicator(false));

                try {
                    const response = await ServicePostUserObject({
                        email: _loginResponse?.email || '',
                        name: _loginResponse?.firstname + ' ' + _loginResponse?.lastname || '',
                        first_name: _loginResponse?.firstname || '',
                        last_name: _loginResponse?.lastname || '',
                        external_user_id: _loginResponse?.guid || '',
                        social_provider: null,
                    });
                    console.log({ response });
                } catch (err) {
                    console.log(err, 'user error');
                } finally {
                    dispatch(setActivityIndicator(false));
                }

                toast.success(T("Toasts:Toast_Description_Login_Successfully"));

                props.onHide();
            })
            .catch((error) => {
                console.log({ error });
                dispatch(setActivityIndicator(false));
                if (error?.response?.status === 400) {
                    toast.error(
                        error?.response?.data?.errors[0]?.description?.toString()
                    );
                }
            });
    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <h4 className="fs-38 medium">{T("Home:Home_Login_Modal_Heading")}</h4>
                <form className="auth-form login" onSubmit={handleLogin}>
                    <div className="form-group">
                        <input
                            value={email}
                            type="email"
                            placeholder={T("Home:Home_Login_Modal_Email_Placeholder")}
                            onChange={(e) => setEmail(e.target.value)}
                            required={true}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            value={password}
                            type={inputType ? "text" : "password"}
                            placeholder={T("Home:Home_Login_Modal_Password_Placeholder")}
                            onChange={(e) => setPassword(e.target.value)}
                            required={true}
                        />
                        <img
                            className="icon"
                            src={inputType ? EyeIconClosed : EyeIcon}
                            onClick={() => setInputType(!inputType)}
                            alt={"icon"}
                        />
                    </div>
                    <div className="login-btn">
                        <button type="submit">{T("Buttons:Login")}</button>
                    </div>

                    <SocialLogins />

                    <a
                        className="fs-12 font-noto"
                        onClick={() => {
                            props.onHide();
                            props.showForgotModal(true);
                        }}
                    >
                        {T("Home:Home_Forget_Password_Header")}?
                    </a>
                </form>
            </Modal.Body>
        </Modal>
    );
};

SignIpModal.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    showForgotModal: PropTypes.func,
};

export default SignIpModal;
